import { useEffect, useState } from "react";
import {
    MIN_EVENT_HEIGHT,
    MAX_EVENT_HEIGHT,
    EVENT_DURATION_MULTIPLIER,
} from "./helpers"

const CustomButtonComponent = (props: any) => {
    const { data } = props;
    const [inputValue, setInputValue] = useState(data.duration.toString());

    const onClick = async (value: number) => {
        const rowData = props.data;

        if (props.node && props.node.data) {
            if (rowData.duration + value > 0) {
                rowData.duration += value;
            }

            if (rowData.duration < MIN_EVENT_HEIGHT) {
                props.node.setRowHeight(MIN_EVENT_HEIGHT * EVENT_DURATION_MULTIPLIER);
            } else {
                props.node.setRowHeight(Math.min(
                    rowData.duration * EVENT_DURATION_MULTIPLIER,
                    MAX_EVENT_HEIGHT
                ));
            }

            props.api.applyTransaction({ update: [rowData] });

            const eventData = {
                idPlanu: rowData.id,
                godzinaRozpoczecia: rowData.startDate,
                czasTrwania: rowData.duration.toString(),
                nrKoncertu: rowData.position,
            };

            await props.context.handleDataUpdate(eventData);
        } else {
            console.error("Props data is undefined");
        }
    };

    useEffect(() => {
        setInputValue(data.duration.toString());
    }, [data.duration]);

    const handleKeyPress = async (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            const rowData = props.data;

            // Check if inputValue is an integer using regex
            const isInteger = /^\d+$/.test(inputValue);

            if (!isInteger || parseInt(inputValue, 10) <= 0) {
                console.error("Invalid duration value");
                setInputValue(rowData.duration.toString());
                return;
            }

            const newDuration = parseInt(inputValue, 10);

            const eventData = {
                idPlanu: rowData.id,
                godzinaRozpoczecia: rowData.startDate,
                czasTrwania: newDuration,
                nrKoncertu: rowData.position,
            };
            if (inputValue < MIN_EVENT_HEIGHT) {
                props.node.setRowHeight(MIN_EVENT_HEIGHT * EVENT_DURATION_MULTIPLIER);
            } else {
                props.node.setRowHeight(Math.min(
                    inputValue * EVENT_DURATION_MULTIPLIER,
                    MAX_EVENT_HEIGHT
                ));
            }

            await props.context.handleDataUpdate(eventData);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    return (
        <div
            style={{
                display: "flex",
                gap: window.innerWidth < 1246 ? "5px" : "20px",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
            }}
        >
            <button className="btn-duration" onClick={() => onClick(-5)}>
                -5
            </button>
            {window.innerWidth > 1246 ? (
                <button className="btn-duration" onClick={() => onClick(-2)}>
                    -2
                </button>
            ) : null}
            <button className="btn-duration" onClick={() => onClick(-1)}>
                -1
            </button>
            {window.innerWidth < 1246 ? (
                <span style={{ minWidth: "15px" }}>{props.data.duration}</span>
            ) : (
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    className="duration-input"
                />
            )}
            <button className="btn-duration" onClick={() => onClick(1)}>
                +1
            </button>
            {window.innerWidth > 1246 ? (
                <button className="btn-duration" onClick={() => onClick(2)}>
                    +2
                </button>
            ) : null}
            <button className="btn-duration" onClick={() => onClick(5)}>
                +5
            </button>
        </div>
    );
};

export default CustomButtonComponent;
